import { useMemo } from 'react';
import { conditionToDsl } from '@platform/core/lib/filterDsl';
import type { IModuleDefinition, IRecordListParams } from '@platform/core/types';
import { useAllRecords } from '@platform/engine/insights/useAllRecords';
import { analysisModuleKey, kindField } from './designSections';
import { JOURNEY_KIND, journeyCodesOf } from './journeyCodes';

/** Відбір усіх наскрізних шляхів робочого простору (прототип рахує їх серед усіх записів аналізу). */
const JOURNEYS: IRecordListParams = { filter: conditionToDsl({ field: kindField, op: 'eq', values: [JOURNEY_KIND] }) };

/**
 * Номери наскрізних шляхів, що проходять через модуль (journeyCodesOf за канонічними назвами модуля англійською й українською, як прототип v4
 * — і для лічильника пункту меню «Шляхи користувачів», і для списку розділу); undefined — шляхи ще вантажаться.
 */
export function useJourneyCodes(ws: string, module: IModuleDefinition | undefined): number[] | undefined {
  const journeys = useAllRecords(ws, analysisModuleKey, JOURNEYS, 1000, !ws || !module);
  const en = module?.module.name.en ?? '';
  const uk = module?.module.name.uk ?? '';
  const pending = journeys.isLoading && journeys.records.length === 0;
  return useMemo(() => (pending ? undefined : journeyCodesOf(journeys.records, en, uk)), [pending, journeys.records, en, uk]);
}
